export function getImportStepTitles(
  importType, importNotSubmitted = false,
  isAdGroupLevelImportEnabled = false
) {
  if (importType === 'GoogleAPIImport') {
    return [
      {
        title: 'GoogleImport_Login_Title',
        additionalClasses: '',
      },
      {
        title: 'GoogleImport_SelectAccount_Title',
        additionalClasses: '',
      },
      {
        title: isAdGroupLevelImportEnabled ?
          'GoogleImport_SelectCampaignsAndAdGroups_Title' : 'GoogleImport_SelectCampaign_Title',
        additionalClasses: '',
      },
      {
        title: 'Import_ImportOptions_WithoutAccount_Title',
        additionalClasses: '',
      },
      {
        title: 'Scheduled_Import_Title',
        additionalClasses: '',
      },
    ];
  }
  if (importType === 'FacebookImport') {
    return [
      {
        title: 'FacebookImport_Login_Title',
        additionalClasses: '',
      },
      {
        title: 'FacebookImport_SelectAccount_Title',
        additionalClasses: '',
      },
      {
        title: 'FacebookImport_SelectCampaign_Title',
        additionalClasses: '',
      },
      {
        title: 'Import_ImportOptions_WithoutAccount_Title',
        additionalClasses: '',
      },
      {
        title: 'Scheduled_Import_Title',
        additionalClasses: '',
      },
    ];
  }
  return [
    {
      title: 'FileImport_UploadFile_Title',
      additionalClasses: '',
    },
    {
      title: 'FileImport_ColumnMatching_Title',
      additionalClasses: '',
    },
    {
      title: 'Import_ImportOptions_WithoutAccount_Title',
      additionalClasses: '',
    },
    {
      title: 'Import_ImportPreview_Title',
      additionalClasses: importNotSubmitted ? 'disabled-section' : '',
    },
  ];
}
